<template>
  <a
    v-if="isFile && value?.url"
    class="lms-show-value__link"
    :href="value.url"
    target="_blank"
    rel="noopener noreferrer"
  >{{ value.viewLabel || 'View File' }}</a>
  <span v-else-if="isFile">—</span>
  <a
    v-else-if="isLink"
    class="lms-show-value__link"
    :href="value.url"
    target="_blank"
    rel="noopener noreferrer"
  >{{ value.display || '—' }}</a>
  <span v-else>{{ text }}</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: { type: [String, Number, Boolean, Object, Array], default: null }
})

const isFile = computed(() =>
  props.value != null &&
  typeof props.value === 'object' &&
  !Array.isArray(props.value) &&
  props.value.kind === 'file'
)

const isLink = computed(() =>
  props.value != null &&
  typeof props.value === 'object' &&
  !Array.isArray(props.value) &&
  !!props.value.url &&
  (props.value.kind === 'reference' || props.value.display != null)
)

const text = computed(() => {
  const v = props.value
  if (v == null || v === '') return '—'
  if (typeof v === 'object') {
    if (v.display != null) return v.display || '—'
    return '—'
  }
  return String(v)
})
</script>

<style scoped>
.lms-show-value__link {
  color: var(--lms-primary, #0B7EA4);
  font-weight: 600;
  text-decoration: none;
}

.lms-show-value__link:hover {
  text-decoration: underline;
}
</style>
